/* src/app/account/partials/tips-section/tips-section.component.scss */
/*# sourceMappingURL=tips-section.component.css.map */
